export const SET_CLIENTS = "CLIENTS/SET_CLIENTS";
export const SET_CLIENT = "CLIENTS/SET_CLIENT";
export const SET_PAGINATION = "CLIENTS/SET_PAGINATION";
export const SET_CLIENTTOUPDATE = "CLIENTS/SET_CLIENTTOUPDATE";
export const SET_HOMEDATA = "CLIENTS/SET_HOMEDATA";
